const MAIN_PORTAL_URL = 'https://app.swiftuni.com';

const normalizePortalUrl = (url) => String(url || '').trim().replace(/\/+$/, '');

export const getPortalUrl = (origin = window.location.origin) => {
  const configuredPortalUrl = normalizePortalUrl(process.env.REACT_APP_PORTAL_URL);
  if (configuredPortalUrl) return configuredPortalUrl;

  const currentOrigin = normalizePortalUrl(origin);
  if (
    currentOrigin.includes('localhost') ||
    currentOrigin.includes('127.0.0.1') ||
    currentOrigin === 'https://staging.swiftuni.com'
  ) {
    return MAIN_PORTAL_URL;
  }

  return currentOrigin;
};

export const isMainPortalUrl = (url) => {
  const normalizedUrl = normalizePortalUrl(url);
  return normalizedUrl === MAIN_PORTAL_URL || normalizedUrl === 'https://staging.swiftuni.com';
};
